import {StyleSheet, Text, View} from 'react-native'

import {isWeb} from '#/platform/detection'
import {atoms as a, useTheme} from '#/alf'
import * as Layout from '#/components/Layout'
import {BenefitSectionPage} from './BenefitSectionPage'
import {HeroSectionPage} from './HeroSectionPage'

export function Homepage() {
  const t = useTheme()

  if (isWeb) {
    return (
      <div className="flex flex-col w-full">
        <HeroSectionPage />
        {/* <BenefitSectionPage /> */}
      </div>
    )
  }

  return (
    <View style={[a.flex_1, a.justify_center, a.align_center, t.atoms.bg]}>
      <View style={[a.flex_1, a.justify_center, a.align_center]}>
        <Text style={[styles.placeholder, t.atoms.text]}>PLACEHOLDER</Text>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  centerContent: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
  },
  placeholder: {
    fontSize: 24,
    fontWeight: '600',
    textAlign: 'center',
  },
})
